import MobileNav from '../plugins/mobileNav';

const initCartPopup = () => {
  const options = {
    activeClass: 'cart-active',
    btnOpenerSelector: '.cart-tool__opener',
    hideOnClickOutside: true,
    outSideSelector: '.cart-tool__drop'
  };

  const holder = document.querySelector('.cart-tool');
  const mobileNav = new MobileNav(holder, options);

  mobileNav.init();
};

const initScrollHeight = () => {
  const holder = jQuery('.cart-tool__drop');
  const win = jQuery(window);

  if (!holder) return;

  const topPanel = holder.find('.cart-tool__heading');
  const middlePanel = holder.find('.cart-tool__body');
  const bottomPanel = holder.find('.cart-tool__footer');

  function resizeHandler() {
    let height = topPanel.outerHeight() + bottomPanel.outerHeight();

    height = win.height() - height;

    middlePanel.css('height', height);
  }

  win.on('resize', resizeHandler);
  resizeHandler();
};

export {initCartPopup, initScrollHeight};
